"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function prop(key) {
  return key && ('string' == typeof key ? function (data) {
    return data[key];
  } : 'object' === _typeof(key) && 'function' === typeof key.exec //regexp
  ? function (data) {
    var v = key.exec(data);
    return v && v[0];
  } : key);
};